/** #109 · Bandeja de pedidos de rollos. Ver `hq-clients/routes.tsx`. */
import { RequestsPage } from '../hq/RequestsPage';
import type { ModuleRoutes } from '../module';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'requests',
  minimumRole: 'admin',
  routes: [{ path: '', element: <RequestsPage /> }],
};
